import { FeaturesListItem } from '@/components/FeaturesList/FeaturesListItem';
import type { SvgProps } from '@/components/Sprite/Icon';

const PLATFORM_FEATURES = [
  {
    icon: 'piggy-bank',
    title: 'multibanking-platform.features.first.title',
    description: 'multibanking-platform.features.first.description',
  },
  {
    icon: 'percent',
    title: 'multibanking-platform.features.second.title',
    description: 'multibanking-platform.features.second.description',
  },
  {
    icon: 'shield-check',
    title: 'multibanking-platform.features.third.title',
    description: 'multibanking-platform.features.third.description',
  },
];
export const FeaturesList = () => {
  return (
    <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-16">
      {PLATFORM_FEATURES.map((feature, index) => (
        <FeaturesListItem
          key={index}
          title={feature.title}
          description={feature.description}
          name={feature.icon as SvgProps['name']}
        />
      ))}
    </div>
  );
};
